import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import mixpanel from "mixpanel-browser";

const root = ReactDOM.createRoot(document.getElementById("root"));
ReactGA.initialize("G-G7SBCQF7Z6");
ReactGA.pageview(window.location.pathname + window.location.search);
// Near entry of your product, init Mixpanel
mixpanel.init(process.env.REACT_APP_MIXPANNEL_TOKEN, {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
});

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID_GOOGLE_LOGIN}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
